import { Button } from '@/components/shadcn/button';

/** Side-by-side proof that the prefixed Tailwind/shadcn layer coexists with Bootstrap. Remove once the migration decision lands. */
export default function UiSpikePage() {
  return (
    <div className="container py-4">
      <h2 className="mb-1">Bootstrap + shadcn — 같은 페이지 공존 검증</h2>
      <p className="text-muted mb-4">
        Tailwind는 <code>tw-</code> prefix + preflight 비활성으로 들어가 있어 기존 Bootstrap 클래스에 손대지 않는다.
      </p>

      <div className="border rounded p-4 mb-4">
        <h4 className="mb-3">Bootstrap — 기존 어드민 (소스 무수정)</h4>
        <div className="mb-3">
          <button className="btn btn-primary me-2">Primary</button>
          <button className="btn btn-outline-secondary me-2">Outline</button>
          <button className="btn btn-danger me-2">Danger</button>
          <span className="badge bg-success me-2">Badge</span>
          <span className="badge bg-warning text-dark">Warning</span>
        </div>
        <div className="border rounded p-3 mb-3" style={{ maxWidth: 560 }}>
          <code>.border .rounded .p-3</code> — margin-bottom 16px / border-radius 6px 유지
        </div>
        <table className="table table-sm" style={{ maxWidth: 560 }}>
          <thead>
            <tr>
              <th>주문</th>
              <th>상태</th>
              <th>금액</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>SS-1001</td>
              <td>Shipped</td>
              <td>$42.00</td>
            </tr>
            <tr>
              <td>SS-1002</td>
              <td>Pending</td>
              <td>$18.50</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="border rounded p-4 mb-4">
        <h4 className="mb-3">shadcn — 신규 (src/components/shadcn/button.tsx)</h4>
        <div className="mb-3 d-flex gap-2 flex-wrap">
          <Button>Default</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="link">Link</Button>
        </div>
        <div className="d-flex gap-2 align-items-center flex-wrap">
          <Button size="sm">Small</Button>
          <Button size="default">Default</Button>
          <Button size="lg">Large</Button>
        </div>
      </div>

      <div className="border rounded p-4">
        <h4 className="mb-3">같은 이름, 다른 시스템</h4>
        <div className="d-flex gap-4 flex-wrap">
          <div>
            <p className="text-muted mb-1">
              <code>.border .rounded</code> (Bootstrap)
            </p>
            <div className="border rounded p-3" style={{ width: 260 }}>
              radius 6px
            </div>
          </div>
          <div>
            <p className="text-muted mb-1">
              <code>.tw-border .tw-rounded-md</code> (shadcn)
            </p>
            <div className="tw-border tw-rounded-md tw-p-3 tw-bg-card" style={{ width: 260 }}>
              radius는 --radius 토큰 기반
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
